import { companyService } from '../../../common/services/api'
import { COMPANY_API_PATHS } from '../../../common/constants/api.js'

export const getCompanyDatos = (contrato, config = {}) => companyService.get(COMPANY_API_PATHS.DATOS(contrato), config)
